import React, { Component } from "react";
import "./SideBar.css";
import axios from "../../axios";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Reactions from "../../pages/stories/Reactions.jsx";
import UserIcon4 from "../../assets/user-image-plc/User_Icon_4.svg";
import { isMobile } from "../../utils/deviceInfo";

import { connect } from "react-redux";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Button,
  Collapse,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import defaultCreateStory from "../../pages/stories/defaultCreateStory";
import defaultMentionStyle from "../../pages/stories/defaultMentionStyle";
import { MentionsInput, Mention } from "react-mentions";
import avatarIcon from "../../assets/default-avatar.png";
import * as url from "../../utils/url";
import {
  storyReactions,
  get_reaction_image,
  get_user_initials,
  profilePicValidityCheck,
} from "../../utils/constants";

import privacyIcon from "../../assets/privacy_icon.svg";
import replies_icon from "../../assets/activity_replies.svg";
import reactions_icon from "../../assets/activity_reactions.svg";
// my_stories_active
import stories_icon from "../../assets/activity_stories.svg";
import * as actionCreators from "../../modules/actions/index";
import UserList from "./ActivityBarUser";

import { staticTitles, whiteLabelStyling } from "../../utils/constants";

class ActivityBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recentUsers: { userCount: 0, userList: [] },
      userReacted: null,
      totalUsers: null,
      path: this.props.location.pathname.split("/"),
      activity: {},
      engagementPopOver: false,
      announcement: {},
      showReactions: null,
      myStatsPopOver: false,
      engagementImage: false,
      scoreboardPopOver: false,
      scoreboard: [],
      showAnnouncementModal: false,
      announcementType: "",
      originalDescription: "",
      isUserShown: false,
      seeMoreLength: 115,
      reactionList: [],
      userReacted: "null",
      userReactions: [],
      showUserReactions: false,
      showReactions: null,
      reactionCounter: 0,
      accordion: [true, false, false, false],
      accordinonTabs: 0,
      announcementWordCount: 0,
      storyCount: 0,
      description: "",
      originalAnnouncement: {},
      // description: {
      //   value: ""
      // },
      title: "",
      disableCreate: false,
      imageError: null,
      ogp: { urlScrape: false, requestUrl: "" },
      image: "",
      is280: false,
      imageUrl: "",
      disableSubmit: true,
      privacy: true,
      isAnonymous: false,
      isAnonymousVisible: true,
      mentionsSelected: [],
      mentionsFound: [],
      mentionWord: "",
      topicAlert: false,
      isDescription: null,
      showReplies: false,
      topics: this.props.topics ? this.props.topics : [],
      topicsSelected: [{ name: "All" }],
      storyType: "",
      suggest: [],
      sentiment: null,
      engagement: [],
      activity: {},
      engagement_replies: null,
      engagement_reactions: null,
    };
    // console.log(this.props)
  }

  closeReactionModal = () => {
    this.setState({ showUserReactions: false });
  };

  findActivityCount = (type, state) => {
    let result;
    if (type == "stories") {
      let { stories } = state.activity;
      result =
        stories && stories[0] && stories[0].storyCount
          ? stories[0].storyCount
          : 0;
    } else if (type === "reactions") {
      let { reactions } = state.activity;
      result =
        reactions && reactions[0] && reactions[0].reactionCount
          ? reactions[0].reactionCount
          : 0;
    } else if (type === "replies") {
      let { replies } = state.activity;
      result =
        replies && replies[0] && replies[0].replyCount
          ? replies[0].replyCount
          : 0;
    } else if (type === "e_replies") {
      let { engagement_replies } = state.activity;
      // result= engagement_replies && engagement_replies[0] && engagement_replies[0].count? engagement_replies[0].count:0
      result = engagement_replies;
    } else if (type === "e_reactions") {
      let { engagement_reactions } = state.activity;
      // console.log('engagement_reactions--- ', engagement_reactions)
      // result= engagement_reactions && engagement_reactions[0] && engagement_reactions[0].count? engagement_reactions[0].count:0
      result = engagement_reactions;
    }

    return result;
  };

  componentWillReceiveProps(nextProps) {
    let { activity } = this.state;
    if (nextProps.activity !== activity) {
      activity = { ...nextProps.activity };
      this.setState({ activity });
    }
  }

  getRecentUsers = () => {
    axios
      .get(url.getRecentUsers)
      .then(({ data }) => {
        let userCount = data.data.userCount;
        let userList = data.data.userList;
        this.setState({
          recentUsers: {
            userList,
            userCount,
          },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getFetchUsers = () => {
    axios
      .get(url.fetchUsers)
      .then(({ data }) => {
        let totalUsers = data.data.length;
        this.setState({
          totalUsers,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getActivityBarUserMetrics = () => {
    axios
      .get(url.activityBarUserMetrics)
      .then(({ data }) => {
        let activity = { ...data.data[0] };

        let userEngagement = activity.total_user_engagement.map((e) => ({
          user: { ...e.user, totalEngagement: e.count },
        }));
        let stories = this.findActivityCount("stories", { activity });
        let replies = this.findActivityCount("replies", { activity });
        let reactions = this.findActivityCount("reactions", { activity });
        let engagement_reactions = this.findActivityCount("e_reactions", {
          activity,
        });
        let engagement_replies = this.findActivityCount("e_replies", {
          activity,
        });
        this.props.setStoryActivity({
          stories,
          reactions,
          replies,
        });
        this.setState({
          activity: {
            stories,
            replies,
            reactions,
          },
          engagement_replies,
          engagement_reactions,
          engagement: [...userEngagement],
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSpotlight = () => {
    axios
      .get(url.getSpotlight)
      .then(({ data }) => {
        let scoreboard = data.data.map((e) => ({
          user: { ...e.user[0], totalEngagement: e.count },
        }));
        this.setState({
          scoreboard: [...scoreboard],
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCurrentAnnouncement = () => {
    axios
      .get(url.currentAnnouncement)
      .then(({ data }) => {
        let announcement = { ...data.data[0] };
        let userReacted =
          announcement.reactionArr &&
          announcement.reactionArr.reactions &&
          announcement.reactionArr.reactions.length > 0
            ? announcement.reactionArr.reactions.filter((e) => {
                return e.userId === this.props.user._id;
              })
            : "null";
        if (Object.keys(announcement).length === 0) {
          announcement = { isArchived: true };
        }
        this.setState({
          userReacted,
          reactionCounter:
            announcement.reactionArr &&
            announcement.reactionArr.reactions &&
            announcement.reactionArr.reactions.length > 0
              ? announcement.reactionArr.reactions.length
              : 0,
          reactionList:
            announcement.reactionArr &&
            announcement.reactionArr.reactions &&
            announcement.reactionArr.reactions.length > 0
              ? announcement.reactionArr.reactions
              : [],
          announcement,
          originalAnnouncement: { ...announcement },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    this.getRecentUsers();
    this.getFetchUsers();
    this.getActivityBarUserMetrics();
    this.getSpotlight();
    this.getCurrentAnnouncement();
  }

  toggleMenu(tab) {
    // console.log(tab)
    const prevState = this.state.accordion;
    // console.log(prevState)
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    // console.log(state)
    this.setState({
      accordion: state,
    });
  }

  isUserTip = () => {
    this.setState((prevState) => ({
      isUserShown: !prevState.isUserShown,
    }));
  };

  renderTotalUsers = () => {
    let { totalUsers } = this.state;
    return (
      <div
        className="activityBarUserCountContainer"
        onClick={() => this.navigateToAllUsers()}
      >
        <img className="" src={privacyIcon} />
        <span className="activityBarUserCount">
          {totalUsers}
          <span className="totalUserCount">Members</span>
        </span>
      </div>
    );
  };

  toggleEngagement = (value) => {
    // console.log(value)
    if (value === "engagementImage") {
      this.setState({
        engagementImage: !this.state.engagementImage,
      });
    } else if (value === "engagementStats") {
      this.setState({
        engagementPopOver: !this.state.engagementPopOver,
      });
    } else if (value == "myStats") {
      this.setState({
        myStatsPopOver: !this.state.myStatsPopOver,
      });
    } else if (value === "scoreboardStats") {
      this.setState({
        scoreboardPopOver: !this.state.scoreboardPopOver,
      });
    }
  };

  addReaction = (val,isAnonymous) => {
    let { user } = this.props;
    let { announcement } = this.state;
    let item = announcement;
    let { reactionList, userReactions, reactionCounter } = this.state;
    // console.log(reactionCounter)
    // console.log(this.props)
    // console.log(user)
    let payload = {
      userId: user._id,
      reaction: val,
      _id: val,
      user,
      noLoader: true,
      createdOn: Date.now,
      storyId: item._id,
      storyOwner: item.userId,
      orgId: user.organizationId._id,
      isAnonymous
    };

    // if(this.state.reactionList.indexOf(payload.userId)>-1)
    let rList = reactionList;
    let uR = userReactions;
    let isReactionListModified = false;
    let isUserListModified = false;

    rList.map((e) => {
      if (e.userId === payload.userId) {
        e.reaction = payload.reaction;
        isReactionListModified = true;
      }
    });

    uR.map((e) => {
      if (e.user._id === payload.userId) {
        e.reaction = val;
        e._id = val;
        e.user.firstName = payload.user.firstName ? payload.user.firstName : "";
        e.user.lastName = payload.user.lastName ? payload.user.lastName : "";
        e.user.profilePic = payload.user.profilePic
          ? payload.user.profilePic
          : "";
        isUserListModified = true;
      }
    });

    if (isReactionListModified) {
      this.setState((prevState) => ({
        reactionList: [...rList],
      }));
    } else {
      if (reactionList.length < 3) {
        this.setState((prevState) => ({
          reactionList: [
            { reaction: val, userId: user._id },
            ...prevState.reactionList,
          ],
          reactionCounter: prevState.reactionCounter + 1,
        }));
      } else {
        this.setState((prevState) => ({
          reactionCounter: prevState.reactionCounter + 1,
        }));
      }
    }

    if (isUserListModified) {
      this.setState((prevState) => ({
        userReactions: [...uR],
        userReacted: [...uR],
      }));
    } else {
      this.setState((prevState) => ({
        userReactions: [payload, ...prevState.userReactions],
        userReacted: [payload, ...prevState.userReactions],
      }));
    }

    // axios.post(url.addAnnouncementReaction(item._id), payload).then(({ data }) => {
    axios.post(url.addAnnouncementReaction, payload).then(({ data }) => {
      // console.log(data)
      this.props.storyMetricsChange({ type: "reactions", value: 1 });
    });
  };

  removeReaction = () => {
    // console.log("remove reaction")
    let userId = this.props.user._id;
    let announcementID = this.state.announcement._id;
    let userRlist =
      this.state.userReacted && this.state.userReacted !== null
        ? this.state.userReacted
        : this.state.userReactions;
    let reactionList = this.state.reactionList;
    // console.log(userRlist, this.props.user.profile, reactionList)
    // console.log(this.state.userReacted, this.state.userReactions)

    if (userRlist.length > 0) {
      // console.log(userRlist)
      let ulist = userRlist.filter((e) => e.userId != this.props.user._id);
      // console.log(ulist)
      this.setState((prevState) => ({
        userReacted: [...ulist],
        userReactions: [...ulist],
      }));
    }

    if (reactionList.length > 0) {
      let rlist = reactionList.filter((e) => e.userId != this.props.user._id);
      // console.log(rlist)
      this.setState((prevState) => ({
        reactionList: [...rlist],
        reactionCounter: prevState.reactionCounter - 1,
      }));
    }
    let payload = {
      announcementID,
      userId,
      noLoader: true,
    };
    axios.post(url.removeAnnouncementReaction, payload).then(({ data }) => {
      this.props.storyMetricsChange({ type: "reactions", value: -1 });

      // console.log(data)
    });
  };

  renderUsers = () => {
    let { recentUsers, isUserShown } = this.state;
    if (
      recentUsers &&
      recentUsers.userList &&
      recentUsers.userList.length > 0
    ) {
      return (
        <div
          style={whiteLabelStyling(
            ["borderTopColor"],
            this.props.user.organizationId
          )}
          className="activityBarUserMetrics borderPadding"
        >
          {/* <h2 onClick={()=> this.toggleMenu(0)}>New Members 
          <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
        </h2> */}
          <div
            className="sidebar-menuItem"
            onClick={() => this.toggleMenu(1)}
            // style={{ fontWeight: "600" }}
            style={{ fontWeight: this.state.accordion[1] ? "600" : "normal" }}
          >
            New Members
            <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
          </div>

          {/* {this.renderTotalUsers()} */}
          <Collapse
            isOpen={this.state.accordion[1]}
            className="newMembersContainer"
          >
            {recentUsers.userList.map((member, idx) => {
              return (
                <UserList key={idx + "recentUsers"} idx={idx} member={member} />
              );
            })}
            {this.renderTotalUsers()}
          </Collapse>
        </div>
      );
    } else {
      return (
        <div
          style={whiteLabelStyling(
            ["borderTopColor"],
            this.props.user.organizationId
          )}
          className="activityBarUserMetrics borderPadding"
        >
          {/* <h2 onClick={()=> this.toggleMenu(0)}>New Members 
          <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
        </h2> */}
          <div
            className="sidebar-menuItem"
            onClick={() => this.toggleMenu(1)}
            // style={{ fontWeight: "600" }}
            style={{ fontWeight: this.state.accordion[1] ? "600" : "normal" }}
          >
            New Members
            <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
          </div>

          {/* {this.renderTotalUsers()} */}
          <Collapse
            isOpen={this.state.accordion[1]}
            className="newMembersContainer"
          >
            {this.renderTotalUsers()}
          </Collapse>
        </div>
      );
    }
  };

  removeReactionHover = () => {
    // console.log('counter---', this.state.reactionCounter)
    this.setState((prevState) => ({
      showReactions: false,
    }));
  };

  showAnnouncementModal = (val) => {
    this.setState({
      showAnnouncementModal: true,
      announcementType: val,
      description: "",
      announcementWordCount: 0,
    });
    if (val === "Edit") {
      let { announcement } = this.state;

      let wordLength = announcement.sanitizedDescription.value.replace(
        /(?:https?|ftp):\/\/[\n\S]+/g,
        ""
      ).length;

      this.setState({
        description: announcement.sanitizedDescription.value,
        originalDescription: announcement.sanitizedDescription.value,
        announcementWordCount: wordLength,
      });
    }
  };
  pickImage = (val) => {
    let selected = storyReactions.filter((x) => x._id === val)[0];
    return selected && selected.image;
  };

  closeAnnouncementModal = () => {
    this.setState({
      showAnnouncementModal: false,
    });
  };

  createMarkup = (input, isShow) => {
    // console.log('input---',input)
    let { announcement, seeMoreLength } = this.state;
    let length = announcement.sanitizedDescription.value.length;
    let wordTxt = announcement.sanitizedDescription.value;
    // let length = input.replace(/<a [\s\S]*?<\/a>/g,'').replace(/<\/?[^>]+(>|$)/g, "").length
    let start = 0;

    if (length > seeMoreLength && !isShow) {
      let newText = input.slice(start, seeMoreLength);
      return { __html: `<div>${newText}...</div>` };
    } else {
      return { __html: `<div>${input}</div>` };
    }
  };

  showReactionList = () => {
    const { announcement } = this.state;
    // console.log('state--', this.state)
    let payload = {
      announcement,
    };
    // console.log(announcement)
    axios
      .get(url.userAnnouncementReactions(announcement._id))
      .then(({ data }) => {
        // console.log(data.data, this.state.userReactions)
        let value = data.data;
        if (value.storyList && value.storyList.length > 0) {
          this.setState((prevState) => ({
            showUserReactions: true,
            userReactions: [...value.storyList],
          }));
        } else if (this.state.userReactions.length > 0) {
          this.setState((prevState) => ({
            showUserReactions: true,
            userReactions: [...prevState.userReactions],
          }));
        }
      });
  };
  renderReactionSymbolsUniqley = (reactionsList) => {
    const symbolImagesSet = new Set();

    for (const item of reactionsList) {
      symbolImagesSet.add(item.reaction);
    }

    const symbolImagesArray = Array.from(symbolImagesSet);

    return (
      <div onClick={this.showReactionList} className="reactionsContainer">
        {symbolImagesArray.map((e, idx) => {
          return (
            <img
              className="reactionItems"
              src={this.pickImage(e)}
              key={idx}
              height="100%"
              width="100%"
            />
          );
        })}
        {/* <span className="reactionCounter">{this.state.reactionCounter}</span> */}
      </div>
    );
  };
  renderAnnouncements = () => {
    let { announcement, seeMoreLength } = this.state;
    // console.log('an--',announcement)
    // if(Object.keys(announcement).length>0){
    if (
      announcement &&
      (announcement.description || announcement.new_desc) &&
      announcement.isArchived !== true
    ) {
      let description =
        announcement.new_desc && announcement.new_desc.length > 0
          ? announcement.new_desc
          : announcement.description;
      return (
        <div
          className="announcementContainer"
          onMouseLeave={this.removeReactionHover}
        >
          {/* <h2 onClick={()=> this.toggleMenu(0)}>New Members 
          <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
          </h2> */}
          <div
            className="sidebar-menuItem announcementTab"
            style={{ fontWeight: "600" }}
          >
            Announcements
          </div>

          <div
            className="announcementMsg"
            dangerouslySetInnerHTML={this.createMarkup(
              description.replace(/\n/g, ""),
              false
            )}
          ></div>
          {announcement.sanitizedDescription.value.length > seeMoreLength ? (
            <span
              className="seeMore"
              onClick={() => this.showAnnouncementModal("Show")}
            >
              see more
            </span>
          ) : null}

          {this.props.user.orgAdmin ? (
            <div className="announcementActions">
              <span onClick={() => this.showAnnouncementModal("Create")}>
                Create
              </span>

              <span onClick={() => this.showAnnouncementModal("Edit")}>
                Edit
              </span>

              <span onClick={() => this.showAnnouncementModal("Archive")}>
                Archive
              </span>
            </div>
          ) : null}
          <div className="reactionsHover announcement">
            <Reactions
              removeReaction={this.removeReaction}
              saveReaction={this.addReaction}
              hideReactions={this.state.showReactions}
              userReacted={this.state.userReacted}
            />
            {this.state.reactionList && this.state.reactionList.length > 0 ? (
              <div
                onClick={this.showReactionList}
                className="reactionsContainer reactionsContainer_left_border"
              >
                {/* <span className="viewReactions">View</span>  */}
                {this.renderReactionSymbolsUniqley(this.state.reactionList)}
                <span className="reactionCounter">
                  ({this.state.reactionCounter})
                </span>
              </div>
            ) : (
              <span className="noReactions">No Reactions</span>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="announcementContainer">
          <div
            className="sidebar-menuItem announcementTab"
            // onClick={()=> this.toggleMenu(0)}
            style={{ fontWeight: "600" }}
            // style={{ fontWeight: this.state.accordion[0] ? "600" : "normal" }}
          >
            Announcements
            {/* <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" /> */}
          </div>

          <span className="announcementMsg">
            No new announcement available at this time. Please check back later.
          </span>

          {this.props.user.orgAdmin ? (
            <div className="announcementActions">
              <span onClick={() => this.showAnnouncementModal("Create")}>
                Create
              </span>
            </div>
          ) : null}
        </div>
      );
    }
    // }
  };

  navigateToAllUsers = () => {
    this.props.history.push("/home/users");
  };

  renderUserMetrics = () => {
    let { activity } = this.state;
    let { reactions, replies, stories } = activity;
    // console.log(activity)
    if (activity && Object.keys(activity).length > 0) {
      return (
        <div
          style={whiteLabelStyling(
            ["borderTopColor"],
            this.props.user.organizationId
          )}
          className="activityBarUserMetrics borderPadding"
        >
          <div
            className="sidebar-menuItem"
            onClick={() => this.toggleMenu(2)}
            style={{ fontWeight: this.state.accordion[2] ? "600" : "normal" }}
          >
            My Activity
            <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
          </div>

          <Collapse isOpen={this.state.accordion[2]}>
            <span className="statInfoPopOver">
              <span className="myStatsText">What's this</span>

              <span
                id="myStatsPopOver"
                style={{ marginRight: "10px" }}
                onClick={() => this.toggleEngagement("myStats")}
              >
                <Tooltip />
              </span>
              <Popover
                placement="right"
                isOpen={this.state.myStatsPopOver}
                target="myStatsPopOver"
                toggle={() => this.toggleEngagement("myStats")}
              >
                <PopoverHeader className="popover-header-tooltip">
                  My Activity
                </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  Number of my {staticTitles.storyItemsL}, replies and reactions
                  this month
                </PopoverBody>
              </Popover>
            </span>

            <div className="iconImages">
              <p>
                <img src={stories_icon} />
                {stories}
                <span>{staticTitles.storyItemsU}</span>
              </p>

              <p>
                <img src={replies_icon} />

                {replies}
                <span>Replies</span>
              </p>

              <p>
                <img src={reactions_icon} />
                {reactions}
                <span>Reactions</span>
              </p>
            </div>
          </Collapse>
        </div>
      );
    }
  };

  renderScoreboard = () => {
    let { scoreboard } = this.state;
    // console.log(scoreboard)

    return (
      <div
        style={whiteLabelStyling(
          ["borderTopColor"],
          this.props.user.organizationId
        )}
        className="activityBarUserMetrics borderPadding isSpotlight"
      >
        {/* <h2 onClick={()=> this.toggleMenu(2)}> Engagement 
        <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
        </h2> */}
        <div
          className="sidebar-menuItem"
          onClick={() => this.toggleMenu(0)}
          style={{ fontWeight: this.state.accordion[0] ? "600" : "normal" }}
        >
          Spotlight
          <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
        </div>

        <Collapse isOpen={this.state.accordion[0]}>
          {scoreboard.length > 0 ? (
            <div>
              <span className="statInfoPopOver">
                <span className="myStatsText">What's this</span>
                <span
                  id="scoreboardStats"
                  style={{ marginRight: "10px" }}
                  onClick={() => this.toggleEngagement("scoreboardStats")}
                >
                  <Tooltip />
                </span>
                <Popover
                  placement="right"
                  isOpen={this.state.scoreboardPopOver}
                  target="scoreboardStats"
                  toggle={() => this.toggleEngagement("scoreboardStats")}
                >
                  <PopoverHeader className="popover-header-tooltip">
                    Spotlight
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    Members in the spotlight have been the most engaged and
                    contributed the most through their posts, reactions and
                    replies this month
                  </PopoverBody>
                </Popover>
              </span>

              <div className="engagementImageContainer">
                {scoreboard.map((member, idx) => {
                  // console.log(member.user)
                  let { user } = member;
                  return (
                    <UserList
                      key={idx + "scoreboard"}
                      idx={idx}
                      member={user}
                      isSpotlight={true}
                    />
                  );
                })}
              </div>
            </div>
          ) : (
            <div>
              <span className="statInfoPopOver">
                <span className="statInfoPopOver">
                  <span className="myStatsText">What's this</span>
                  <span
                    id="scoreboardStats"
                    style={{ marginRight: "10px" }}
                    onClick={() => this.toggleEngagement("scoreboardStats")}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="right"
                    isOpen={this.state.scoreboardPopOver}
                    target="scoreboardStats"
                    toggle={() => this.toggleEngagement("scoreboardStats")}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Spotlight
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Members in the spotlight have been the most engaged and
                      contributed the most through their posts, reactions and
                      replies this month
                    </PopoverBody>
                  </Popover>
                </span>
              </span>
              <span className="announcementMsg">
                No one in spotlight right now.
              </span>
            </div>
          )}
        </Collapse>
      </div>
    );
  };

  renderEngagementMetrics = () => {
    let { engagement_replies, engagement_reactions, engagement } = this.state;

    return (
      <div
        style={whiteLabelStyling(
          ["borderTopColor"],
          this.props.user.organizationId
        )}
        className="activityBarUserMetrics borderPadding"
      >
        {/* <h2 onClick={()=> this.toggleMenu(2)}> Engagement 
        <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
        </h2> */}
        <div
          className="sidebar-menuItem"
          onClick={() => this.toggleMenu(3)}
          style={{ fontWeight: this.state.accordion[3] ? "600" : "normal" }}
        >
          Engagement
          <i className="flaticon-down-arrow sidebar-flaticon-down-arrow activityBarArrow" />
        </div>

        <Collapse isOpen={this.state.accordion[3]}>
          {engagement && engagement.length > 0 ? (
            <div>
              <span className="statInfoPopOver">
                <span className="myStatsText">What's this</span>
                <span
                  id="engagementStats"
                  style={{ marginRight: "10px" }}
                  onClick={() => this.toggleEngagement("engagementStats")}
                >
                  <Tooltip />
                </span>
                <Popover
                  placement="right"
                  isOpen={this.state.engagementPopOver}
                  target="engagementStats"
                  toggle={() => this.toggleEngagement("engagementStats")}
                >
                  <PopoverHeader className="popover-header-tooltip">
                    Engagement
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    Number of times others have replied to or reacted to my{" "}
                    {staticTitles.storyItemsL} this month
                  </PopoverBody>
                </Popover>
              </span>

              <div className="engagementImageContainer">
                {engagement.map((member, idx) => {
                  // console.log(member.user)
                  let { user } = member;
                  return (
                    <UserList
                      key={idx + "engagement"}
                      idx={idx}
                      member={user}
                    />
                  );
                })}

                <span
                  id="engagementImage"
                  style={{ marginRight: "10px" }}
                  onClick={() => this.toggleEngagement("engagementImage")}
                >
                  <Tooltip />
                </span>
              </div>
              <Popover
                placement="right"
                isOpen={this.state.engagementImage}
                target="engagementImage"
                toggle={() => this.toggleEngagement("engagementImage")}
              >
                <PopoverHeader className="popover-header-tooltip">
                  Most Engaged
                </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  People who are most engaged with my {staticTitles.storyItemsL}{" "}
                  this month
                </PopoverBody>
              </Popover>
              <div className="iconImages">
                <p>
                  <img src={replies_icon} />

                  {engagement_replies}
                  <span>Replies</span>
                </p>

                <p>
                  <img src={reactions_icon} />
                  {engagement_reactions}
                  <span>Reactions</span>
                </p>
              </div>
            </div>
          ) : (
            <div>
              <span className="statInfoPopOver">
                <span className="statInfoPopOver">
                  <span className="myStatsText">What's this</span>
                  <span
                    id="engagementStats"
                    style={{ marginRight: "10px" }}
                    onClick={() => this.toggleEngagement("engagementStats")}
                  >
                    <Tooltip />
                  </span>
                  <Popover
                    placement="right"
                    isOpen={this.state.engagementPopOver}
                    target="engagementStats"
                    toggle={() => this.toggleEngagement("engagementStats")}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      Engagement
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      Number of times others have replied to or reacted to my{" "}
                      {staticTitles.storyItemsL} this month
                    </PopoverBody>
                  </Popover>
                </span>
              </span>
              No engagement stats to show.
            </div>
          )}
        </Collapse>
      </div>
    );
  };

  findUsers = (query, callback) => {
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map((user) => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${
            user.email
          }", "name": "${user.firstName + " " + user.lastName}"}`,
          // {_id:user._id, email: user.email, idx},
          // name: user.firstName + " " + user.lastName,
          // _id: user._id,
          // email: user.email,
        }))
      )
      .then(callback);
  };

  selectUserMention = (val) => {
    // console.log('val--', val)
    if (val && val.name) {
      let name = val.name.replace(/ /g, "_");
      // .replace(" ", "_")

      let text = this.state.description + name;

      let replaceM = text.lastIndexOf("@") + 1;
      let str1 = text.slice(replaceM);
      let spaceI = str1.indexOf(" ") + 1;
      let diffW = str1.length - name.length;
      let str2 = str1.slice(diffW);
      str1 = str1.slice();
      // console.log(replaceM, str1,str2)

      text = text.replace(str1, str2);
      // console.log('text 2 - ',text)
      // console.log(text)
      this.setState((prevState) => ({
        mentionsFound: [],
        mentionWord: "",
        // description: {value: text},
        description: text,

        mentionsSelected: [...prevState.mentionsSelected, val],
      }));
    }
  };

  handleChangeAnnDescription = async (event) => {
    let descriptionContext = event.target.value;
    let wordLength = descriptionContext.replace(
      /(?:https?|ftp):\/\/[\n\S]+/g,
      ""
    ).length;

    if (wordLength <= 280) {
      this.setState({
        is280: false,
      });
      let valCheck = event.target.value
        .replace(/<\/?![^>]+(>|$)/g, "")
        .replace(/[\. ,:-]+/g, "")
        .replace(/^\n|\n$/g, "");
      let { ogp } = this.state;
      let {
        ogImage,
        ogDesc,
        ogTitle,
        ogType,
        ogUrl,
        ogSiteName,
        urlScrape,
      } = ogp;
      // announcementWordCount
      this.setState({
        announcementWordCount: wordLength,
      });
      if (descriptionContext.indexOf("http") > -1 && urlScrape !== true) {
        let httpIndex = descriptionContext.indexOf("http");
        let httpString = descriptionContext.substr(httpIndex);
        let afterHttp =
          httpString.indexOf(" ") > -1
            ? httpString.indexOf(" ")
            : descriptionContext.length;

        let urlString = descriptionContext.substr(httpIndex, afterHttp);

        // let wordLength= valCheck.length - urlString.length
        // this.setState({
        //   announcementWordCount: wordLength
        // })

        axios
          .get(url.getOpenGraphData, {
            params: {
              url: urlString,
            },
          })
          .then(({ data }) => {
            // console.log(data,'---data---', data.data.data)
            let { requestUrl } = data.data;
            if (data.data.data) {
              let resp = data.data.data;
              let { ogUrl } = resp;
              // ogImage = resp.ogImage.url
              // ogDesc = resp.ogDescription
              // ogTitle = resp.ogTitle
              // ogType = resp.ogType
              // ogUrl = resp.ogUrl
              // ogSiteName = resp.ogSiteName
              ogUrl = resp.ogUrl ? resp.ogUrl : requestUrl;

              let twitterAppNameGooglePlay = resp.twitterAppNameGooglePlay;
              let urlName = ogUrl ? ogUrl : requestUrl;
              let startNameURL = urlName.indexOf("w.") + 2;
              let endNameURL = urlName.indexOf(".com");
              let startEndDiff = endNameURL - startNameURL;
              let siteName = urlName.substr(startNameURL, startEndDiff);

              let ogSiteName = resp.ogSiteName
                ? resp.ogSiteName
                : twitterAppNameGooglePlay
                ? twitterAppNameGooglePlay
                : siteName;

              urlScrape = true;

              this.setState({
                ogp: {
                  ...resp,
                  requestUrl: data.data.requestUrl,
                  urlScrape: true,
                  ogSiteName,
                  ogUrl,
                  // urlScrape,
                  // ogImage,
                  // ogDesc,
                  // ogTitle,
                  // ogType,
                  // ogUrl,
                  // ogSiteName
                },
              });
            }
          });
      }

      if (descriptionContext.length === 0) {
        urlScrape = false;
        ogp = {};
      }
      // console.log('desc---', descriptionContext)

      this.setState({
        description: descriptionContext,
        disableSubmit: valCheck.length === 0,
        ogp: {
          urlScrape,
          ...ogp,
        },
      });
    }
    if (wordLength > 280) {
      this.setState({
        is280: true,
      });
    }
  };

  handleCreateAnnouncement = () => {
    let { is280 } = this.state;
    if (!is280) {
      let that = this;
      let {
        announcementType,
        originalAnnouncement,
        announcement,
        description,
        isAnonymous,
        privacy,
        title,
        mentionsSelected,
        topicsSelected,
        ogp,
      } = this.state;
      let axiosUrl;
      // if(announcementType==="Edit"){
      //   announcement = {...originalAnnouncement, ...announcement}
      // }
      description = description.replace(/^\s+|\s+$/g, "");
      // replace(/^\n|\n$/gm, '').replace(/\s/gm, "")

      let dValue =
        description && description != ""
          ? description
              .replace(/<\/?![^>]+(>|$)/g, "")
              .replace(/[\. ,:-]+/g, "")
          : 0;
      const formData = new FormData();
      var Filter = require("bad-words"),
        filter = new Filter();
      filter.addWords("suck", "shit");
      filter.removeWords("sex", "God", "god");

      let isUrl;
      let cleanDesc = description;
      // ? filter.clean(description): false
      // .replace(/^\n|\n$/gm, '').replace(/\s/gm, "")
      // console.log(cleanDesc)

      if (dValue.length > 0 && cleanDesc === description) {
        let desc = `<span> ${description.replace(
          /<\/?![^>]+(>|$)/g,
          ""
        )} </span>`;
        let sanitizedDescription = {};
        let mentionsText = `<span>${description.replace(
          /<\/?![^>]+(>|$)/g,
          ""
        )}</span>`;
        sanitizedDescription.value = `${description.replace(
          /<\/?![^>]+(>|$)/g,
          ""
        )}`;
        sanitizedDescription.userReferences = [];

        let isMention = desc.indexOf("@") > -1 ? true : false;

        let desArr = desc.split(" ");

        let mArray = desArr.filter((e) => {
          if (e.indexOf("@") > -1) {
            return e;
          }
        });

        let mentions = mentionsSelected.filter((e) => {
          let valMention = `({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;

          if (desc.includes(valMention)) {
            let strReplace = `@[@${e.name}]({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;

            desc = desc.replace(
              strReplace,
              `<a class="userMentionWord" href="/home/${this.props.user.organizationId._id}/profile/${e._id}">@${e.name}</a>`
            );

            sanitizedDescription.value = sanitizedDescription.value.replace(
              strReplace,
              `@${e.name}`
            );
            sanitizedDescription.userReferences.push(e._id);
            isMention = true;
            return e;
          }
        });

        let splitDesc = desc.split(" ").map((e) => {
          let val = e;
          if (e.indexOf("http") > -1 && e.indexOf("www") == -1) {
            isUrl = true;
            val = e.replace(
              /((http|https)?:\/\/[^\s]+)/g,
              `<a class="urlLink" href='$1' target='_blank' >$1</a>`
            );
          } else if (e.indexOf("www") > -1 && e.indexOf("http") == -1) {
            isUrl = true;
            val = e.replace(
              /(www[^\s]+)/g,
              `<a class="urlLink" href='${"https://"}$1' target='_blank' >$1</a>`
            );
          } else if (e.indexOf("www") > -1 && e.indexOf("http") > -1) {
            isUrl = true;
            val = e.replace(
              /((http|https)[^\s]+)/g,
              `<a class="urlLink" href='$1' target='_blank' >$1</a>`
            );
          }
          return val;
        });

        desc = splitDesc.join(" ");

        if (desc.length > 0) {
          let payload = { description: desc, title, isAnonymous, privacy, ogp };
          formData.append("description", desc);
          formData.append("title", title);
          formData.append("privacy", privacy);
          formData.append("ogp", ogp);
          payload.ogp = ogp;
          if (isAnonymous) {
            payload.isAnonymous = isAnonymous;
            formData.append("isAnonymous", isAnonymous);
          } else if (isAnonymous === undefined) {
            payload.isAnonymous = false;
            formData.append("isAnonymous", false);
          }
          if (mentions && mentions.length > 0) {
            payload.users = mentions;
            formData.append("users", mentions);
          }
          payload.isUrl = isUrl;
          formData.append("isUrl", isUrl);

          payload.isMention = isMention;
          formData.append("isMention", isMention);

          payload.sanitizedDescription = sanitizedDescription;
          formData.append("sanitizedDescription", sanitizedDescription);

          payload.mentionsText = mentionsText;
          formData.append("mentionsText", mentionsText);
          payload.orgName = this.props.user.organizationId.name;
          payload.template = this.props.storyType;
          formData.append("template", this.props.storyType);
          payload.topics = topicsSelected.filter((e) => e.name !== "All");
          formData.append("topics", payload.topics);

          formData.append("image", this.state.image);
          formData.append("imageUrl", this.state.imageUrl);
          formData.append("isMobile", false);

          if (announcementType === "Edit") {
            payload = {
              ...originalAnnouncement,
              ...payload,
              lastUpdate: {
                updatedBy: this.props.user._id,
                datetime: moment(Date.now()).toISOString(),
              },
              original: {
                ...originalAnnouncement,
                lastUpdate: { ...originalAnnouncement.lastUpdate },
              },
            };

            axiosUrl = url.editAnnouncement;
          } else {
            payload = {
              ...payload,
              createdOn: moment(Date.now()).toISOString(),
              lastUpdate: {
                updatedBy: this.props.user._id,
                datetime: moment(Date.now()).toISOString(),
              },
            };
            axiosUrl = url.addAnnouncement;

            that.setState({
              userReacted: null,
              reactionCounter: 0,
              reactionList: [],
            });
          }

          let { organizationId } = this.props.user;

          // let simpleEmailBranding =  organizationId.whiteLabel && organizationId.whiteLabel.simpleEmailBranding?true:false

          payload = { ...payload, org_data: organizationId };

          formData.append("payload", JSON.stringify(payload));

          axios
            .post(axiosUrl, formData)
            .then(({ data }) => {
              console.log(data.data, data.data.data);
              // console.log("succ---", payload)
              that.setState({
                announcement: { ...data.data, description: desc },
                "announcement.description": desc,
                originalAnnouncement: { ...data.data },
                originalDescription: data.data.description,
                description: "",
                title: "",
                privacy: true,
                topicsSelected: [],
                showAnnouncementModal: false,
              });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.setState({ isDescription: "" });
        }
      } else {
        this.setState({ disableCreate: false });

        if (description && description !== "" && description.length === 0) {
          this.setState({ isDescription: "No description" });
        }
        if (cleanDesc !== description && description.value.length > 0) {
          this.setState({ isBadWords: true });
        }
      }
    }
  };

  handleArchiveAnnouncement = () => {
    let { announcement } = this.state;
    this.setState({
      announcement: { isArchived: true },
      showAnnouncementModal: false,
    });
    axios.post(url.archiveAnnouncement, announcement).then((data) => {
      // console.log("archived!")
    });
  };

  checkDescriptionLength = (value) => {
    console.log(value);
    let result = value.replace(/^\s+|\s+$/g, "");
    // .replace(/(^\s*(?!.+)\n+)|(\n+\s+(?!.+)$)/g, "")
    // .replace(/\s/g, "").replace( /[\r\n]+/gm, " " )
    return result;
  };

  renderSubmitAnnouncementBtn = (value) => {
    let { is280, description, announcement, originalDescription } = this.state;
    console.log(is280, description, value);
    if (value === "Edit") {
      if (
        this.checkDescriptionLength(originalDescription) ===
          this.checkDescriptionLength(description) ||
        is280 ||
        this.checkDescriptionLength(description).length === 0
      ) {
        return (
          <Button
            className="announcementBtns continueAnnBtn"
            onClick={this.closeAnnouncementModal}
          >
            {" "}
            Submit{" "}
          </Button>
        );
      } else {
        return (
          <Button
            className="announcementBtns continueAnnBtn"
            onClick={this.handleCreateAnnouncement}
          >
            {" "}
            Submit{" "}
          </Button>
        );
      }
    } else {
      console.log("Create--");
      if (is280 || this.checkDescriptionLength(description).length === 0) {
        return (
          <Button className="announcementBtns wordCountSubmitBtn">
            {" "}
            Submit{" "}
          </Button>
        );
      } else {
        return (
          <Button
            className="announcementBtns continueAnnBtn"
            onClick={this.handleCreateAnnouncement}
          >
            {" "}
            Submit{" "}
          </Button>
        );
      }
    }
  };

  renderAnnouncementContent = () => {
    let {
      announcementType,
      announcement,
      description,
      originalDescription,
      is280,
    } = this.state;
    // console.log(description, announcement)
    // let content = Object.keys(announcement).length>0&&announcement.sanitizedDescription.value?announcement.sanitizedDescription.value:description

    // description = announcementType==="Edit"?content:description

    if (announcementType === "Create" || announcementType === "Edit") {
      return (
        <div>
          <div className="modal-content-wrapper word-break">
            <div className="input-wrapper">
              <div className="createStoryInput createAnnInput">
                <MentionsInput
                  placeholder={"Write announcement here"}
                  singleLine={false}
                  style={defaultCreateStory}
                  value={description}
                  onChange={this.handleChangeAnnDescription}
                >
                  <Mention
                    trigger="@"
                    style={defaultMentionStyle}
                    data={this.findUsers}
                    onAdd={this.selectUserMention}
                  />
                </MentionsInput>
              </div>
            </div>
            {announcementType === "Create" ? (
              <span className="announcementAlert">
                Please note creating a new announcement will replace the one you
                already have. Do you want to proceed?
              </span>
            ) : null}
          </div>
          <Row className="mt30" style={{ marginLeft: "0px" }}>
            <Col
              className="noLeftPadding"
              sm={{ size: 6 }}
              md={{ size: 6 }}
              style={{ paddingLeft: "0px" }}
            >
              {this.renderSubmitAnnouncementBtn(announcementType)}
            </Col>

            <Col sm={{ size: 6 }} md={{ size: 6 }}>
              <Button
                className="announcementBtns closeAnnBtn"
                onClick={this.closeAnnouncementModal}
              >
                {" "}
                Close{" "}
              </Button>{" "}
            </Col>
            {/* closeAnnouncementModal */}
          </Row>
        </div>
      );
    } else if (announcementType === "Archive") {
      return (
        <div>
          <div className="modal-content-wrapper word-break">
            You are about to archive this announcement. Would you like to
            continue with this action?
          </div>
          <Row className="mt30" style={{ marginLeft: "0px" }}>
            <Col
              className="noLeftPadding"
              sm={{ size: 6 }}
              md={{ size: 6 }}
              style={{ paddingLeft: "0px" }}
            >
              <Button
                className="announcementBtns archiveAnnBtn"
                onClick={this.handleArchiveAnnouncement}
              >
                {" "}
                Archive{" "}
              </Button>
            </Col>

            <Col sm={{ size: 6 }} md={{ size: 6 }}>
              <Button
                className="announcementBtns closeAnnBtn"
                onClick={this.closeAnnouncementModal}
              >
                {" "}
                Close{" "}
              </Button>{" "}
            </Col>
            {/* closeAnnouncementModal */}
          </Row>
        </div>
      );
    } else if (announcementType === "Show") {
      return (
        <div>
          <div className="modal-content-wrapper word-break">
            <div
              className=""
              dangerouslySetInnerHTML={this.createMarkup(
                announcement.description.replace(/\n/g, "<br />"),
                true
              )}
            ></div>
          </div>
          <Row
            className="mt30"
            style={{ marginLeft: "0px", paddingLeft: "0px" }}
          >
            <Col
              sm={{ size: 6 }}
              md={{ size: 6 }}
              style={{ marginLeft: "0px", paddingLeft: "0px" }}
            >
              <Button
                className="announcementBtns closeAnnBtn floatLeft"
                onClick={this.closeAnnouncementModal}
              >
                {" "}
                Close{" "}
              </Button>{" "}
            </Col>
          </Row>
        </div>
      );
    }
  };

  renderWordLength = () => {
    let { announcementType, announcementWordCount, is280 } = this.state;

    if (announcementType !== "Archive") {
      if (is280) {
        return (
          <span className="wordCount">({announcementWordCount} / 280)</span>
        );
      } else {
        return <span>({announcementWordCount} / 280)</span>;
      }
    }
  };

  showReactionText = (reaction) => {
    let res = storyReactions.filter((e) => e._id == reaction._id)[0];
    return (
      <span
        className="story_reaction_modal_rname"
        style={{ color: `${res["color"]}` }}
      >
        {" "}
        {res.name}{" "}
      </span>
    );
  };

  render() {
    let { toolCategory } = { ...this.props.currentTool.category };
    let {
      activity,
      description,
      showAnnouncementModal,
      is280,
      announcementWordCount,
      announcementType,
    } = this.state;

    return (
      <div className="activityBarContainer">
        {this.renderAnnouncements()}

        {this.renderScoreboard()}

        {this.renderUsers()}

        {/* {Object.keys(activity).length > 0?
           this.renderUsers()
          :
          null} */}

        {/* {this.renderTotalUsers()} */}

        {this.renderUserMetrics()}

        {/* {Object.keys(activity).length > 0?
             this.renderUserMetrics()
            
            :
            null
           }  */}

        {this.renderEngagementMetrics()}

        {/* {Object.keys(activity).length > 0 ?
              this.renderEngagementMetrics()
            :
            null
           }  */}

        {this.state.showUserReactions ? (
          <Modal
            isOpen={this.state.showUserReactions}
            className="archive-modal show-user-reactions"
          >
            <ModalBody>
              <div className="modal-title reactionListTitle">
                {this.state.userReactions.length} Reactions
              </div>
              <div className="modal-content-wrapper word-break reactionModal">
                {this.state.userReactions && this.state.userReactions.length > 0
                  ? this.state.userReactions.map((e, idx) => {
                      return (
                        <div className="userReactionContainer" key={idx}>
                          <div>
                          {e.isAnonymous ?   <img
                              //  onClick={this.goToProfile}
                              className="userReactionPic"
                              src={avatarIcon}
                            /> :e.user && 
                          profilePicValidityCheck(e.user.profilePic) &&
                          e.user.profilePic.length > 0 ? (
                            <img
                              //  onClick={this.goToProfile}
                              className="userReactionPic"
                              src={e.user.profilePic}
                            />
                          ) : e.user.firstName && e.user.lastName ? (
                            <span
                              className="spotlightUserInitials"
                              // onClick={this.goToProfile}
                              data-letters={get_user_initials(e.user)}
                            ></span>
                          ) : null}

                          {/* <img className="userReactionPic" src={e.user.profilePic || UserIcon4}/> */}
                          <span className="userReactionName">
                         {e.isAnonymous ? e.userId == this.props.user._id ? "You (anonymous)" : "Anonymous User" :  <span>{e.user.firstName} {e.user.lastName}</span>  } 
                            
                          </span>
                          </div>


                          <div className="d-flex align-items-center">
                          <img
                              className="reactionModalImage mr-2"
                              src={get_reaction_image(e._id)}
                              //  src={this.pickImage(e._id)}
                            />

                            {this.showReactionText(e)}
                          </div>

                    
                        </div>
                      );
                    })
                  : null}
                {/* {this.state.userReactions && this.state.userReactions.length>0?
                          this.state.userReactions.map( (e,idx)=>{
                            return (
                              <div className="userReactionContainer" key={idx}>
                                <img className="userReactionPic" src={e.user.profilePic || UserIcon4}/>
                                <span className="userReactionName">
                                  {e.user.firstName} {e.user.lastName}
                                </span>
                                <img className="reactionModalImage" src={this.pickImage(e._id)}/>
                              </div>
                            )
                          })
                        :
                        null
                        } */}
              </div>
              <Row
                className={`mt30 ${isMobile && "reaction-close"}`}
                style={{ marginLeft: "9px" }}
              >
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="archive-button"
                    onClick={this.closeReactionModal}
                  >
                    Close
                  </Button>{" "}
                </Col>
                {/* <Col sm={{ size: 4 }} md={{ size: 4 }}>
                          <Button className="cancel-button float-right" onClick={this.closeReactionModal}>
                              Cancel
                          </Button>
                        </Col> */}
              </Row>
            </ModalBody>
          </Modal>
        ) : null}

        <Modal
          isOpen={showAnnouncementModal}
          style={{ maxWidth: "580px !important" }}
          className="announcementModal"
        >
          <ModalBody>
            <div className="modal-title">
              {announcementType !== "Show" ? announcementType : null}{" "}
              Announcement{" "}
              {announcementType !== "Show" ? this.renderWordLength() : null}
              <span
                className="model-close"
                onClick={this.closeAnnouncementModal}
              >
                <i className="flaticon-close"></i>
              </span>
            </div>

            {this.renderAnnouncementContent()}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
    activity: state.user.profile.activity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setStoryActivity: (data) => dispatch(actionCreators.setStoryActivity(data)),
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ActivityBar)
);
